(function (App, $) {

  var store = '', 
    brand = '', 
    site, 
    country, 
    agent, 
    inhouse, 
    lanuage, 
    altLanguage, 
    productLabel,
    brandLabel,
    warrantyVariant,
    nonWarrantyVariant,
    m;

  App.init = function(utils) {

    // Get the store information.
    this.country = siteCountry;
    this.language = defaultLanguage;
    
	
	if(App.country!=="us" && App.country!=="ca"){
		this.altLanguage = window.altLanguage;
		
	}else{
		this.altLanguage = altLanguage;
	}
	this.site = siteLabel;
	
    if(typeof globalProductLabel !== 'undefined') {
      this.productLabel = globalProductLabel;
      this.brandLabel = globalBrandLabel;
	  
	  if(App.country!=="us" && App.country!=="ca"){
		this.warrantyVariant = window.warrantyVariant;
        this.nonWarrantyVariant = window.nonWarrantyVariant;
	  }
	  else{
			this.warrantyVariant = warrantyVariant;
			this.nonWarrantyVariant = nonWarrantyVariant;
	  }
    }
    
	
    $('.' + this.country + '-flag').show();
    $('#country-select').val(this.country);

    App.createModel();
    App.loadParams(); 
    App.deserialize();
    App.loadParams();
    App.serialize();
    App.setLogo(App.m.selectedBrand);
    

    bindUIActions();

    if($('body').hasClass('body-services')) {   
      RepairRequest.init();
    }

    if($('body').hasClass('body-account')) {   
      Account.init();
    }

    if($('body').hasClass('body-checkout')) {   
      Checkout.init();
    }

    // If we're in Canada and In House show the user that
    // we are in CA.
    if(this.country.toLowerCase() == 'ca' && this.inhouse) {
      $('#ca-indicator').show();
    }
  }

  // Update the estimated price based on the services selected.
  App.updatePrice = function() {
    var noWarranty = !App.m.inWarranty;
    var subtotal = 0;
    var onquote = false;

    App.m.prices.labor = 0;
    App.m.prices.shipping = jsData.fees.shipping.standard;
    
    var hasLabor = false;
    var isPremium = false;
    for(i = 0; i < App.m.selectedServices.length; i++) {

      // If the is special damaged case then treat everything 
      // as in warranty.
      if(App.m.agent.fred || App.m.agent.damage) {
        App.m.prices.shipping = 0;
        break;
      }

      var service = App.m.selectedServices[i];

      // Non-warranty services.
      if(!service.warranty || !App.m.inWarranty) {
        noWarranty = true;
        subtotal += parseInt(service.price);
      }

      // Requires a quote.
      if(service.onquote) {
        onquote = true;
      }

      // Does this item require labor charge?
      var exempt = false;      

      // Is the product type exempt?
      for(var j = 0; j < jsData.fees.labor.exempt.length; j++) {
        if(App.m.selectedProduct.name == jsData.fees.labor.exempt[j]) {
          exempt = true;
        }
      }
          
      // Is it exempt by tag?
      for(var j = 0; j < jsData.fees.labor.exemptTags.length; j++) {
        for(var k = 0; k < service.tags.length; k++) {
          if(jsData.fees.labor.exemptTags[j] == service.tags[k]) {
            exempt = true;
          }
        }
      }

      if(!exempt) {
        hasLabor = true;

        // See if we have premium labor.
        for(var j = 0; j < jsData.fees.labor.premiumTags.length; j++) {
          for(var k = 0; k < service.tags.length; k++) {
            if(jsData.fees.labor.premiumTags[j] == service.tags[k]) {
              isPremium = true;
            }
          }
        }
      }

      // See if we have premium shipping.
      for(var j = 0; j < jsData.fees.shipping.premiumTags.length; j++) {
        for(var k = 0; k < service.tags.length; k++) {
          if(jsData.fees.shipping.premiumTags[j] == service.tags[k]) {
            App.m.prices.shipping = jsData.fees.shipping.premium;
          }
        }
      }
    }

    if(hasLabor) {
      App.m.prices.labor = isPremium ? jsData.fees.labor.premium : jsData.fees.labor.standard;
    }

    if(App.m.selectedServices.length == 0 || (App.m.inWarranty && !noWarranty)) {
      App.m.prices.labor = 0;
      App.m.prices.shipping = 0;
    }
    

    App.m.prices.onquote = onquote;
    App.m.hasNonWarranty = noWarranty;

    // Calculate any taxes.
    if(typeof estimateTax !== 'undefined' && estimateTax) {
      App.m.prices.taxes = estimateTax;
    }
    else {
      var taxRates = Cookies.get('fossiltaxes');
      App.m.prices.taxes = 0;
      if(taxRates != undefined && typeof shippingState !== 'undefined' && shippingState && (subtotal > 0 || App.m.prices.shipping > 0 || App.m.prices.labor > 0 )) {
        taxRates = JSON.parse(taxRates);
        var rate = 0;
        for(var i = 0; i < taxRates.length; i++ ) {
          if(taxRates[i].state == shippingState) {
            rate = taxRates[i].value;
          }
        }
        App.m.prices.taxes = ((subtotal/100 + App.m.prices.shipping + App.m.prices.labor) * rate/100).toFixed(2);
      }
    }
    
    // Calculate the total estimate.
    var total = subtotal / 100;
    total += App.m.prices.labor;
    total += App.m.prices.shipping;
    total += parseFloat(App.m.prices.taxes);
    if(!App.m.hasNonWarranty)
      total = 0;

    App.m.prices.total = Math.round(total*100)/100;
  };


  var bindUIActions = function () {
    $('.contactUs').click(function() {
		var href = $(this).attr('href');
		var b = App.m.selectedBrand;
      
		for(var i = 0; i < brands.length; i++) {
			if(b == brands[i].name) {
			  b = brands[i].handle;
			}
		}
		if (b == 'bmw' ){
			if(App.country == 'ca' ) {
				if(chosenLanguage == 'English') {
					href='https://bmw.fgservices.com/hc/en-ca/requests/new?ticket_form_id=207766';
				} else if(chosenLanguage == 'French') {
					href='https://bmw.fgservices.com/hc/fr-ca/requests/new?ticket_form_id=207766';
				}
			} else if(App.country == 'uk') {
				href = 'https://bmw.fgservices.com/hc/en-gb/requests/new?ticket_form_id=207766';
			} else if(App.country == 'fr') {
				href = 'https://bmw.fgservices.com/hc/fr/requests/new?ticket_form_id=207766';
			} else if(App.country == 'de') {
				href = 'https://bmw.fgservices.com/hc/de/requests/new?ticket_form_id=207766';
			} else {
				href ='https://bmw.fgservices.com/hc/requests/new?ticket_form_id=207766';
			}
		}
		else if (b == 'puma') {
			if(App.country == 'ca' ) {
				if(chosenLanguage == 'English') {
					href='https://puma.fgservices.com/hc/en-ca/requests/new?ticket_form_id=207766';
				} else if(chosenLanguage == 'French') {
					href='https://puma.fgservices.com/hc/fr-ca/requests/new?ticket_form_id=207766';
				}
			} else if(App.country == 'uk') {
				href = 'https://puma.fgservices.com/hc/en-gb/requests/new?ticket_form_id=207766';
			} else if(App.country == 'fr') {
				href = 'https://puma.fgservices.com/hc/fr/requests/new?ticket_form_id=207766';
			} else if(App.country == 'de') {
				href = 'https://puma.fgservices.com/hc/de/requests/new?ticket_form_id=207766';
			} else {
				href ='https://puma.fgservices.com/hc/requests/new?ticket_form_id=207766';
			}
		}
		$(this).attr('href', href);
		window.location.href = href;

 });
 
 
    $('#country button').on('click', function(e) {
      if($('#country-select').val() != App.country) {
        var country = Utils.getSiteUrl($('#country-select').val());
        window.location.href = country; 
      }    
      window.Overlay.hide();
    });
  
    $('.country').on('click', function() {
      $('.popup').hide();
      $('#country').show();
      window.Overlay.show();
    });

    $('.cancel-modal').on('click', function(e) {
      e.preventDefault();
      window.Overlay.hide();
    });

    $('.help-with-params').on('click', function(e) {
      var href = $(this).attr('href');
      if(href.indexOf('{brand}') < 0) {
        return true;
      }
      
      e.preventDefault();  

      var b = App.m.selectedBrand;
      for(var i = 0; i < brands.length; i++) {
        if(b == brands[i].name) {
          b = brands[i].handle;
        }
      }

      // Set brand, country, and language
      href = href.replace('{brand}', b);
      href = href.replace('{country}', App.country);
      href = href.replace('{language}', App.language);
	  
	 if($(this).hasClass('leather')) {
		  if (b == 'bmw'){
			if (App.country == 'ca'){
	            if(chosenLanguage == 'English') {
				  href = 'https://bmw.fgservices.com/hc/en-ca';
				} else if(chosenLanguage == 'French') {
			      href = 'https://bmw.fgservices.com/hc/fr-ca';
				}	
            } else if (App.country == 'fr'){
				href = 'https://bmw.fgservices.com/hc/fr';
			} else if (App.country == 'de'){
				href = 'https://bmw.fgservices.com/hc/de';
			} else if (App.country == 'us'){
				href = 'https://bmw.fgservices.com/hc/en-us';
			} else if (App.country == 'uk'){
				href ='https://bmw.fgservices.com/hc/en-gb';
			}
		  }
		  
		  else if (b == 'puma') {
			if (App.country == 'ca' ) {
				if (chosenLanguage == 'English') {
					href = 'https://puma.fgservices.com/hc/en-ca';
				} else if (chosenLanguage == 'French') {
					href = 'https://puma.fgservices.com/hc/fr-ca';
				}
			} else if (App.country == 'uk') {
					href = 'https://puma.fgservices.com/hc/en-gb';
			} else if (App.country == 'fr') {
				    href = 'https://puma.fgservices.com/hc/fr';
			} else if (App.country == 'de') {
				    href = 'https://puma.fgservices.com/hc/de';
			} else if (App.country == 'us') {
				    href = 'https://puma.fgservices.com/hc/en-us';   
			}
		}	 
	}
	  
	if($(this).hasClass('countryLink')) {
		
		 if (b == 'bmw'){
			if (App.country == 'ca'){
	            if(chosenLanguage == 'English') {
				  href = 'https://bmw.fgservices.com/hc/en-ca';
				} else if(chosenLanguage == 'French') {
			      href = 'https://bmw.fgservices.com/hc/fr-ca';
				}	
            } else if (App.country == 'fr'){
				href = 'https://bmw.fgservices.com/hc/fr/articles/360025044992';
			} else if (App.country == 'de'){
				 href = 'https://bmw.fgservices.com/hc/de/articles/360025044992';
			} else if (App.country == 'us'){
				href = 'https://bmw.fgservices.com/hc/en-us';
			} else if (App.country == 'uk'){
				href = 'https://bmw.fgservices.com/hc/en-gb/articles/360025044992';
			}
		  }
		  
		  else if (b == 'puma') {
			if (App.country == 'ca' ) {
				if (chosenLanguage == 'English') {
					href = 'https://puma.fgservices.com/hc/en-ca';
				} else if (chosenLanguage == 'French') {
					href = 'https://puma.fgservices.com/hc/fr-ca';
				}
			} else if (App.country == 'uk') {
					href = 'https://puma.fgservices.com/hc/en-gb';
			} else if (App.country == 'fr') {
				    href = 'https://puma.fgservices.com/hc/fr';
			} else if (App.country == 'de') {
				    href = 'https://puma.fgservices.com/hc/de';
			} else if (App.country == 'us') {
				    href = 'https://puma.fgservices.com/hc/en-us';   
			}
		}	 
		
	}
      // If this is a warranty link, look for an override URL.
      if($(this).hasClass('warranty-help')) {

        if(b == 'fossil') href = 'https://services.fossilgroup.com/hc/articles/115004488663?brand=fossil';
        if(b == 'fossilswiss') href = 'https://services.fossilgroup.com/hc/articles/115004488643?brand=fossilswiss';
        if(b == 'adidas') href = 'https://services.fossilgroup.com/hc/articles/115004727806?brand=adidas';
        if(b == 'armaniexchange') href = 'https://services.fossilgroup.com/hc/articles/115004704303?brand=armaniexchange';
        if(b == 'burberry') href = 'https://services.fossilgroup.com/hc/articles/115004706703?brand=burberry';
        if(b == 'chaps') href = 'https://services.fossilgroup.com/hc/articles/115004706743?brand=chaps';
        if(b == 'diesel') href = 'https://services.fossilgroup.com/hc/articles/115004706803?brand=diesel';
        if(b == 'dkny') href = 'https://services.fossilgroup.com/hc/articles/115004706923?brand=dkny';
        if(b == 'emporioarmani') href = 'https://services.fossilgroup.com/hc/articles/115004724946?brand=emporioarmani';
        if(b == 'karllagerfeld') href = 'https://services.fossilgroup.com/hc/articles/115004703923?brand=karllagerfeld';
        if(b == 'katespade') href = 'https://services.fossilgroup.com/hc/articles/115004724886?brand=katespade';
        if(b == 'marcjacobs') href = 'https://services.fossilgroup.com/hc/articles/115004704223?brand=marcjacobs';
        if(b == 'mk') href = 'https://services.fossilgroup.com/hc/articles/115004704083?brand=mk';
        if(b == 'michele') href = 'https://services.fossilgroup.com/hc/articles/115004724866?brand=michele';
        if(b == 'relic') href = 'https://services.fossilgroup.com/hc/articles/115005485683?brand=relic';
        if(b == 'skagen') href = 'https://services.fossilgroup.com/hc/articles/115004501226?brand=skagen';
        if(b == 'toryburch') href = 'https://services.fossilgroup.com/hc/articles/115004704203?brand=toryburch';
        if(b == 'zodiac') href = 'https://services.fossilgroup.com/hc/articles/115004724846?brand=zodiac';
        if(b == 'bmw') href = 'https://bmw.fgservices.com/hc/articles/360001407646-BMW-Watch-Warranty';
        if(b == 'puma') href = 'https://puma.fgservices.com/hc/en-us/articles/360026405611';
		if (b == 'bmw'){
			if (App.country == 'ca'){
	            if(chosenLanguage == 'English') {
				   href = 'https://bmw.fgservices.com/hc/en-ca/articles/360001407646-BMW-Watch-Warranty';
				} else if(chosenLanguage == 'French') {
			       href = 'https://bmw.fgservices.com/hc/fr-ca/articles/360001407646-BMW-Watch-Warranty';
				}	
            } else if (App.country == 'fr'){
				href ='https://bmw.fgservices.com/hc/fr/articles/360001407646-Garantie-relative-�-la-montre-BMW';
			} else if (App.country == 'de'){
				href ='https://bmw.fgservices.com/hc/de/articles/360001407646-BMW-Uhren-Internationale-Garantie-von-zwei-2-Jahren';
			} else if (App.country == 'uk'){
				href ='https://bmw.fgservices.com/hc/en-gb/articles/360001407646-BMW-Watch-Warranty';
			}
		}
		  
		else if (b == 'puma') {
			if (App.country == 'ca' ) {
				if (chosenLanguage == 'English') {
				    href = 'https://puma.fgservices.com/hc/en-ca/articles/360026405611';
				} else if (chosenLanguage == 'French') {
					href = 'https://puma.fgservices.com/hc/fr-ca/articles/360026405611';
				}
			} else if (App.country == 'uk') {
					href ='https://puma.fgservices.com/hc/en-gb/articles/360026405611';
			} else if (App.country == 'fr') {
				    href ='https://puma.fgservices.com/hc/fr/articles/360026405611';
			} else if (App.country == 'de') {
				    href ='https://puma.fgservices.com/hc/de/articles/360026405611';
			}
		}
		
	  }

      $(this).attr('href', href);
      // window.open(href);
      window.location.href = href;

    });
  }


  // Load configuration parameters.
  App.loadParams = function() {

    this.store = Utils.queryParam('store');
    if(this.store != undefined) {
        Cookies.set('fossilstore', this.store, { expires: 100 });
		sessionStorage.setItem("fossilstore", this.store);
    }

    this.brand = Utils.queryParam('brand');
    if(this.brand != undefined) {
        for(var i = 0; i < brands.length; i++) {
          if(this.brand == brands[i].handle) {
            this.brand = brands[i].name;
            this.m.selectedBrand = this.brand;
          }
        }
        Cookies.set('fossilbrand', this.brand, { expires: 100 });

        // Only set the selected brand if the parameter is valid.
        for(var i = 0; i < brands.length; i++) {
          if(this.brand == brands[i].name) {
            this.m.selectedBrand = this.brand;
          }
        }
    }

    // Special flag for in house workers. Essentially a persistent
    // agent with no tracking of the store.
    this.inhouse = (Utils.queryParam('inhouse') != undefined);
    if(this.inhouse) {
		sessionStorage.setItem("inhouse", this.inhouse);
        Cookies.set('inhouse', this.inhouse, { expires: 365 });
 		Cookies.remove('agent');
		sessionStorage.removeItem("agent");
    }
	this.agent = (Utils.queryParam('agent') != undefined);
	if(this.agent) {
		sessionStorage.setItem("agent", this.agent);
        Cookies.set('agent', this.agent, { expires: 365 });
		Cookies.remove('inhouse');
		sessionStorage.removeItem("inhouse");
    }	

    var product = Utils.queryParam('product');
    
    if(product && productData) {
      var products = productData.unique()
      
      // Only set the selected brand if the parameter is valid.
    
      for(var i = 0; i < products.length; i++) {
        if(product.toLowerCase() == products[i].toLowerCase()) {
          this.m.selectedProduct.name =  products[i];
        }
      }
    }

    this.store = Cookies.get('fossilstore');
    this.brand = Cookies.get('fossilbrand');
    //this.inhouse = Cookies.get('inhouse');
	this.inhouse = sessionStorage.getItem("inhouse");
    this.agent = (Utils.queryParam('agent') != undefined);

    // In house agents shouldn't have a store set.
    if(this.inhouse) {
      Cookies.remove('fossilstore');
    }

    
    if(this.brand && product && this.m.selectedProduct.name) {
      this.serialize();
      if(window.location.href.indexOf('services') >= 0) {
        RepairRequest.showStep(2);
      }
    }
  }


  // Update the site logo based on the brand.
  App.setLogo = function(brand) {
    var brandName = (brand != undefined) ? brand : this.brand;
    
    if(brandName != undefined) {
      var handle = brandName.replace(/ /g, '_').toLowerCase();
      var logo = jsData.logos[handle] == undefined ? '' : jsData.logos[handle];
      $('.brand-logo').attr('src', logo);
    }
  }

  // Save the request data to storage so we can track
  // across page loads.
  App.serialize = function() {

    var data = {
      'product':          App.m.selectedProduct.name,
      'sku':              App.m.selectedProduct.sku,
      'serial':           App.m.selectedProduct.serial,
      'brand':            App.m.selectedBrand,
      'warranty':         App.m.inWarranty,
      'hasNonWarranty':   App.m.hasNonWarranty,
      'selectedServices': App.m.selectedServices,
      'note':             App.m.note,
      'agent' :           App.m.agent.enabled,
      'agentName' :       App.m.agent.name,
      'agentNote' :       App.m.agent.note,
      'agentDamage' :     App.m.agent.damage,
      'agentFred':        App.m.agent.fred
    };
    
    Cookies.set('fossilrepair', JSON.stringify(data), 30);
    return data;
  }


  // Load request data from storage so we can continue
  // a previous session.
  App.deserialize = function() {

    var cookieData = Cookies.get('fossilrepair');
    var data = undefined;

    if(requestData) {
      data = JSON.parse(requestData);
    }
    else if(cookieData != undefined) {
      data = JSON.parse(cookieData);
    }

    if(data != undefined) {
      console.log(data);
      App.m.selectedProduct.name   = data.product;
      App.m.selectedProduct.sku    = data.sku;
      App.m.selectedProduct.serial = data.serial;
      App.m.selectedBrand          = data.brand;
      App.m.inWarranty             = data.warranty;
      App.m.hasNonWarranty         = data.hasNonWarranty;
      App.m.selectedServices       = data.selectedServices;
      App.m.note                   = data.note;
      App.m.agent.enabled          = (App.agent) ? true : data.agent;
      App.m.agent.inhouse          = (App.inhouse) ? true : data.inhouse;
      App.m.agent.note             = data.agentNote;
      App.m.agent.name             = data.agentName;
      App.m.agent.damage           = data.agentDamage;
      App.m.agent.fred             = data.agentFred;
    }
  }


  // Create a data model for tracking state across the app.
  App.createModel = function() {

    App.m = new Vue({

      el: '#repair-app',
      delimiters: ['${', '}'],
      data: {

        agent: {
          inhouse: (App.inhouse == undefined) ? false : true,
          enabled: (App.agent == undefined) ? false : true,
          name: '',
          note: '',
          damage: false,
          fred: false
        },

        products: [],
        selectedProduct: {
            name: '',
            sku: '',
            serial: '',
            image: ''
        },

        services: [],
        selectedServices: [],

        brands: [],
        availableBrands: [],
        selectedBrand: '',
        
        inWarranty: '',
        hasNonWarranty: false,
        note: '',
        prices: {
          onquote: false,
          services: 0,
          labor: jsData.fees.labor.standard,
          shipping: jsData.fees.shipping.standard,
          total: 0,
          taxes: 0
        },

        draft: {
          id: '',
          items: [],
          tax: 0
        }
      },
      methods: {
        formatPrice: function(value) {
          return Utils.formatPrice(value);
        }
      }
    });
  }

}(window.App = window.App || {}, jQuery));

$(document).ready(function() {
  App.init();
});


